import { COUNCIL, MANAGEMENT, DEPARTMENTS } from "./data/org";
import { Department } from "./components/Department";
import { Dashboard } from "./components/Dashboard";
import { Toolbar } from "./components/Toolbar";
import { EventsLog } from "./components/EventsLog";
import { MeetingRoom } from "./components/MeetingRoom";
import { MeetingsArchive } from "./components/MeetingsArchive";
import { OfficeFloor } from "./components/OfficeFloor";
import { DemandsBoard } from "./components/DemandsBoard";
import { AboutView } from "./components/AboutView";
import { ClientsView } from "./components/ClientsView";
import { Gallery } from "./components/Gallery";
import { DailyBriefing } from "./components/DailyBriefing";
import { SocialMediaView } from "./components/SocialMediaView";
import { OpsRoom } from "./components/OpsRoom";
import { LibraryView } from "./components/LibraryView";
import { FunnelView } from "./components/FunnelView";
import { useUI } from "./store/ui";

export default function App() {
  const view = useUI(s => s.view);

  return (
    <div id="app-root" className="min-h-screen text-ink">
      {/* TOP RULE */}
      <div className="px-8 pt-6">
        <div className="flex items-center justify-between text-[11px] font-mono uppercase">
          <span>AVPC — RH · 01</span>
          <span className="opacity-50">arquitetura do comando</span>
          <span>MMXXVI / SP</span>
        </div>
        <div className="rule mt-2" />
      </div>

      {/* TITLE */}
      <header className="px-8 pt-8 pb-6 text-center">
        <h1 className="font-display font-black uppercase tracking-tight text-[18vw] md:text-[12vw] leading-[0.85]">
          Agência VPC
        </h1>
        <div className="flex justify-center mt-2">
          <span className="w-3 h-3 bg-red inline-block" />
        </div>
        <p className="font-serif italic text-2xl md:text-3xl mt-3 text-paper">
          Departamento de Recursos Humanos — contrate, demita, reorganize.
        </p>
      </header>

      <Toolbar />

      {view === "rh" && <RHView />}
      {view === "office" && <OfficeFloor />}
      {view === "demands" && <DemandsBoard />}
      {view === "about" && <AboutView />}
      {view === "clients" && <ClientsView />}
      {view === "gallery" && <Gallery />}
      {view === "briefing" && <DailyBriefing />}
      {view === "social" && <SocialMediaView />}
      {view === "ops" && <OpsRoom />}
      {view === "library" && <LibraryView />}
      {view === "funnel" && <FunnelView />}
      {view === "log" && <EventsLog />}
      {view === "meeting" && <MeetingRoom />}
      {view === "meetings" && <MeetingsArchive />}

      {/* FOOTER */}
      <footer className="px-8 pb-10">
        <div className="rule" />
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 py-4 text-[11px] font-mono uppercase">
          <span>VPC · AGÊNCIA</span>
          <span>R3 GROUP LLC</span>
          <span className="text-right md:text-left">MMXXVI</span>
          <span className="text-right">PRANCHA 01 / 01</span>
        </div>
        <div className="rule" />
        <p className="font-serif italic text-paper text-center pt-4">
          “Estrutura de holding premium — operação de agência, infoproduto e fintech sob um mesmo comando.”
        </p>
      </footer>
    </div>
  );
}

function RHView() {
  return (
    <>
      <div className="px-8 mt-6">
        <div className="rule" />
        <div className="flex items-center justify-between py-3 text-[11px] font-mono uppercase">
          <span>01 · painel executivo</span>
          <span className="opacity-50">resumo da folha</span>
        </div>
      </div>
      <div className="px-8 pb-10">
        <Dashboard />
      </div>

      <div className="px-8">
        <div className="rule" />
        <div className="flex items-center justify-between py-3 text-[11px] font-mono uppercase">
          <span>02 · conselho · gerência</span>
          <span className="opacity-50">comando estratégico</span>
        </div>
      </div>
      <div className="px-8 pb-10 grid gap-6 xl:grid-cols-2">
        <Department dept={COUNCIL}    tone="council" />
        <Department dept={MANAGEMENT} tone="management" />
      </div>

      <div className="px-8">
        <div className="rule" />
        <div className="flex items-center justify-between py-3 text-[11px] font-mono uppercase">
          <span>03 · departamentos operacionais</span>
          <span className="opacity-50">07 unidades</span>
        </div>
      </div>
      <div className="px-8 pb-16 space-y-6">
        {DEPARTMENTS.map(d => <Department key={d.id} dept={d} />)}
      </div>
    </>
  );
}
